import { tss } from "tss-react/mui"

type PostNestedSelectors = "root"
    | "title"
    | "description"
    | "tag"
    | "date"
    | "subContainer"
    | "actionsContainer"
    | "postHeader"
    | "imageContainer"

export const useStyles = tss
    .withName("Post")
    .withNestedSelectors<PostNestedSelectors>()
    .create(({ theme, classes }) => ({
        root: {
            backgroundColor: '#FFFFFF',
            borderRadius: 8,
            boxShadow: '0px 3px 20px #EDEDF0',
            flexDirection: 'column',
            flexWrap: 'nowrap',
            padding: 0,
            '& div:nth-child(2)': {
                flex: '1 0 auto'
            },
            [theme.breakpoints.down('md')]: {
                height: 'auto',
            }
        },
        imageContainer: {
            margin: 0,
            '& img': {
                display: 'block',
                // height: '-webkit-fill-available',
                maxHeight: 337,
                maxWidth: '100%',
                [theme.breakpoints.down('md')]: {
                    maxHeight: 'initial',
                }
            },
        },
        subContainer: {
            textAlign: 'left',
            padding: '24px 24px 17px',
        },
        actionsWrapper: {
            alignItems: 'flex-end',
            display: 'flex',
        },
        actionsContainer: {
            padding: '0px 24px 24px',
        },
        title: {
            color: theme.palette.tertiary.main,
            marginBottom: 8,
            fontSize: 18,
            fontWeight: 700,
            lineHeight: '24px',
            letterSpacing: '0.15px',
            [theme.breakpoints.down('md')]: {
                color: theme.palette.tertiary.main,
                fontSize: 18,
                fontWeight: 900,
                lineHeight: '24px',
                letterSpacing: '0.15px',
            }
        },
        tag: {
            color: theme.palette.primary.main,

            fontSize: 12,
            fontWeight: 400,
            lineHeight: '16px',
            letterSpacing: '0.4px',
        },
        date: {
            color: '#555555',

            fontSize: 12,
            fontWeight: 400,
            lineHeight: '16px',
            letterSpacing: '0.4px',
        },
        description: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '20px',
            letterSpacing: '0.25px',
        },
        readMoreButton: {
            fontSize: 18,
            fontWeight: 500,
            lineHeight: '24px',
            letterSpacing: '0.15px',
            marginTop: 24,
        },
        postHeader: {
            marginBottom: 16,
        },
        fullWidth: {
            textAlign: 'left',
            [`&.${classes.root}`]: {
                flexWrap: 'wrap',
                flexDirection: 'row',
            },
            [`&.${classes.title}`]: {
                fontSize: 26,
                fontWeight: 700,
                lineHeight: '32px',
                letterSpacing: '0.15px',
            },
            [`&.${classes.description}`]: {
                fontSize: 18,
                fontWeight: 400,
                lineHeight: '30px',
                letterSpacing: '0.25px',
            },
            [`&.${classes.tag}`]: {
                fontSize: 16,
                fontWeight: 400,
                lineHeight: '16px',
                letterSpacing: '0.4px',
            },
            [`&.${classes.date}`]: {
                fontSize: 18,
                fontWeight: 400,
                lineHeight: '16px',
                letterSpacing: '0.4px',
            },
            [`&.${classes.subContainer}`]: {
                flexDirection: 'column',
                flexWrap: 'nowrap',
                height: '100%',
                '& div:nth-child(1)': {
                    flex: '1 0 auto'
                },
            },
            [`&.${classes.actionsContainer}`]: {
                padding: 0,
            },
            [`&.${classes.postHeader}`]: {
                marginBottom: 26,
            },
            [`&.${classes.imageContainer} img`]: {
                height: '100%',
                objectFit: 'cover',
            },
        }
    }))